import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-check-circle",
  templateUrl: "./check-circle.component.html",
  styleUrls: ["./check-circle.component.scss"],
})
export class CheckCircleComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
